import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Button } from '../../globalStyles';
import {
  InfoSec,
  InfoRow,
  InfoColumn,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  ImgWrapper,
  Img
} from './InfoSection.elements';
import img4 from '../../images/img4.png';
import moving from '../../images/moving.png';
// import escalator from '../../images/escalator.jpg';
import { BsDot } from 'react-icons/bs'
function Escalators({
  primary,
  lightBg,
  topLine,
  lightTopLine,
  lightText,
  lightTextDesc,
  headline,
  description,
  buttonLabel,
  img,
  bglight,
  alt,
  imgStart,
  start,
  boxsh
}) {
  return (
    <>
      <InfoSec lightBg={true} boxsh={false}>
        <Container>
           <InfoRow style={{ flexDirection:'row-reverse'}} >
          <InfoColumn>
              <ImgWrapper>
                <Img src={img4} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Escalators & Moving walks for commercial, administrative, and heavy traffic buildings</Heading>
                 <TopLine lightTopLine={lightTopLine} bglight={  bglight} style={{ color:'#fff'}}
>Product Highlights:</TopLine>
                <Subtitle lightTextDesc={true}><BsDot  style={{ fontSize:"15px" }} /> We provide indoor & outdoor Escalators and Moving Walks. <br /> <BsDot  style={{ fontSize:"15px" }} /> Safe and Reliable Solutions. <br /> <BsDot  style={{ fontSize:"15px" }} /> Industry leading after sales service, maintenance plans are applied according the type of your building. <br /> <BsDot  style={{ fontSize:"15px" }} /> Also, we provide inclined & horizontal products.</Subtitle>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <InfoRow imgStart={imgStart}>
          <InfoColumn>
              <ImgWrapper start={start}>
                {/* <Img src={escalator} alt={alt} /> */}
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Escalator</Heading>
            
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
          <br />
                    <br/>

          <InfoRow style={{ flexDirection:'row-reverse'}} >
          <InfoColumn>
              <ImgWrapper>
                <Img src={moving} alt={alt} />
              </ImgWrapper>
            </InfoColumn>
            <InfoColumn>
              <TextWrapper>
                <Heading lightText={true}>Moving walks</Heading>
              </TextWrapper>
            </InfoColumn>
          </InfoRow>
        </Container>
      </InfoSec>
    </>
  );
}

export default Escalators;
